<template>
  <div style="padding: 40px; max-width: 1400px; margin: 0 auto;">
    <h2 style="margin-bottom: 20px;">考试记录管理</h2>

    <div style="margin-bottom: 15px;">
      <el-button type="primary" @click="loadRecords" :loading="loading">加载记录</el-button>
      <span style="margin-left: 15px; color: #999;" v-if="allRecords.length">共 {{ allRecords.length }} 条记录</span>
    </div>

    <el-tabs v-model="currentTab">
      <el-tab-pane label="队伍" name="team">
        <el-table :data="teamRecords" border>
          <el-table-column prop="test_subject" label="学科" width="130"></el-table-column>
          <el-table-column label="类型" width="100">
            <template slot-scope="scope">
              {{ scope.row.template ? scope.row.template.test_type : '' }}
            </template>
          </el-table-column>
          <el-table-column label="学校名" width="150">
            <template slot-scope="scope">
              {{ scope.row.account ? scope.row.account.account_name : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="team_code" label="队伍号" width="70"></el-table-column>
          <el-table-column prop="test_scores" label="得分" width="60"></el-table-column>
          <el-table-column prop="test_status" label="状态" width="70"></el-table-column>
          <el-table-column label="提交时间" width="160">
            <template slot-scope="scope">
              {{ formatTime(scope.row.update_time) }}
            </template>
          </el-table-column>
          <el-table-column label="提交人" width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.uploader_name">{{ scope.row.uploader_name }}</span>
              <br v-if="scope.row.uploader_email">
              <span v-if="scope.row.uploader_email" style="color:#999;font-size:12px;">{{ scope.row.uploader_email }}</span>
            </template>
          </el-table-column>
          <el-table-column label="确认详情" min-width="200">
            <template slot-scope="scope">
              <div v-if="scope.row.team_confirm_details && scope.row.team_confirm_details.length">
                <div style="margin-bottom:2px;font-size:12px;color:#666;">
                  {{ scope.row.team_confirm_count }} 人已确认
                </div>
                <el-tag
                  v-for="(item, idx) in scope.row.team_confirm_details"
                  :key="idx"
                  size="small"
                  style="margin-right:4px;margin-bottom:2px;"
                >
                  {{ item.name }}
                </el-tag>
              </div>
              <span v-else style="color:#ccc;">无确认记录</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="danger" size="small" @click="remove(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="个人" name="personal">
        <el-table :data="personalRecords" border>
          <el-table-column prop="test_subject" label="学科" width="130"></el-table-column>
          <el-table-column label="类型" width="100">
            <template slot-scope="scope">
              {{ scope.row.template ? scope.row.template.test_type : '' }}
            </template>
          </el-table-column>
          <el-table-column label="邮箱">
            <template slot-scope="scope">
              {{ scope.row.student ? scope.row.student.student_email : '' }}
            </template>
          </el-table-column>
          <el-table-column label="姓名" width="150">
            <template slot-scope="scope">
              {{ scope.row.student ? scope.row.student.student_lastName + scope.row.student.student_givenName : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="test_scores" label="得分" width="60"></el-table-column>
          <el-table-column prop="test_status" label="状态" width="70"></el-table-column>
          <el-table-column label="提交时间" width="160">
            <template slot-scope="scope">
              {{ formatTime(scope.row.update_time) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="danger" size="small" @click="remove(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import request from '../../utils/request'

const PROJECT_CODE = '2026Envirothon_Asia'

export default {
  data() {
    return {
      currentTab: 'team',
      allRecords: [],
      loading: false
    }
  },
  computed: {
    teamRecords() {
      return this.allRecords.filter(r => r.record_type === 'team')
    },
    personalRecords() {
      return this.allRecords.filter(r => r.record_type === 'personal')
    }
  },
  mounted() {
    this.loadRecords()
  },
  methods: {
    formatTime(timestamp) {
      if (!timestamp) return ''
      const d = new Date(timestamp * 1000)
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    loadRecords() {
      this.loading = true
      request.post('./index.php', {
        function: 'getTestsByProject',
        project_code: PROJECT_CODE
      }).then(res => {
        this.allRecords = res.data || []
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    remove(row) {
      this.$confirm('确认删除该考试记录？删除后学生可重新交卷。', '确认删除', {
        type: 'warning'
      }).then(() => {
        const promises = [
          request.post('./index.php', {
            function: 'removeTestById',
            id: row._id.$id
          })
        ]
        // team 记录同时重置 relay 进入次数
        if (row.record_type === 'team' && row.test_taker_id) {
          promises.push(request.post('./index.php', {
            function: 'resetRelayEntryCount',
            template_id: row.template_id,
            project_code: row.project_code,
            team_id: row.test_taker_id
          }))
        }
        Promise.all(promises).then(() => {
          this.$message.success('删除成功')
          this.loadRecords()
        })
      }).catch(() => {})
    }
  }
}
</script>
